import Vue from 'vue'
import processRawdataHex from 'horus-parser/src/process-rawdata-hex.js'
import { detectFirstOffset } from './detect-first-hb'
import Slicer from 'horus-parser/src/Slicer.js'
import { rejoin } from 'horus-parser/src/tools/rejoiner.mjs'
import { selectOperations } from 'horus-parser/src/tools/select-operations.mjs'
import { go } from '../../models/index.js'

function store(key, value) {
  if (value == null || value.trim().length < 1 || value === 'null') {
    localStorage.removeItem(key)
  } else {
    localStorage.setItem(key, value)
  }
}

function get(key, defVal) {
  const r = localStorage.getItem(key)
  return r == null ? defVal : r
}

const LS_HEXINPUT = 'RawdataInspector_hexInput'
const LS_GLOBALS = 'RawdataInspector_globals'
const LS_START_FW = 'RawdataInspector_startFwVersion'

export default new Vue({
  data() {
    return {
      tabItems: [
        { label: 'Input', value: '#input', dirty: false },
        { label: 'Render', value: '#render', dirty: false },
        { label: 'Output', value: '#slices', dirty: false },
        { label: 'CAN Sniff', value: '#canSniff', dirty: false },
        { label: 'Logs', value: '#logs', dirty: false },
      ],

      allFrames: [],
      allOperations: [],
      allLogLines: [],

      startFwVersion: get(LS_START_FW, '0400'),
      hexInput: get(LS_HEXINPUT),
      globals: JSON.parse(get(LS_GLOBALS, '{}')),
      bytes: [],
      sliceMs: null,
      sliceResult: null
    }
  },
  watch: {
    startFwVersion() {
      store(LS_START_FW, this.startFwVersion)
    },
    hexInput() {
      store(LS_HEXINPUT, this.hexInput)
    },
    globals() {
      store(LS_GLOBALS, JSON.stringify(this.globals))
    }
  },
  methods: {
    async fetch({ clientId, fromHbId, untilHbId }) {
      const ps = { fromHbId, untilHbId }
      const { blob } = await go.download(`hb-export/${clientId}`, ps)
      const str = await blob.text()
      this.hexInput = str
    },

    parse() {
      // Converte hex para bytes e reformata para popular a aba Render
      this.render()

      // Tenta determinar o primeiro offset (se a str
      // for na verdade um HBList).
      const startPointer = detectFirstOffset(this.hexInput)

      const t0 = +Date.now()

      const slicer = new Slicer(this.bytes, {
        startPointer,
        keepBytesInLapses: false,
        keepBytesInFrames: 'onlyGarbage',
        lastFwVersion: parseInt(this.startFwVersion || '0400', 16),
        newAsciiFormat: true
        // , logFn: console.log
      })

      this.sliceResult = slicer.slice()

      this.sliceMs = +Date.now() - t0

      // Logo depois de fazer o slice, faz o rejoin para
      // associar lapses-frames com header- e footer-frames.
      this.allFrames = rejoin(this.sliceResult.frames)

      // Também "destrincha" os frames acima, criando uma linha
      // para cada operation, tanto on- quanto off-trips.
      this.allOperations = selectOperations(this.allFrames)

      this.allLogLines = this.allOperations.filter(x => isLog(x))
    },

    render() {
      this.bytes = processRawdataHex(this.hexInput, this.globals, {
        binary: true
      })
    },

    getFrameBytes(frame) {
      let start = frame.prevLapseStart
      if (start == null) start = frame.prevFrameStart
      if (start == null) start = frame.startIndex
      let end = frame.endIndex

      return this.bytes.slice(start, end)
    }
  }
})

function isLog(op) {
  if (op.typeStr == 'log') return true
  if (op.typeStr == 'verboseLog') return true
  if (op.typeStr == 'generic' && op.subTypeStr == 'log-gsm') return true
  if (op.typeStr == 'generic' && op.subTypeStr == 'log-wifi') return true
  return false
}